module.exports = __webpack_public_path__ + "img/signin-bg.0a112bff.png";